import { i as e } from "./index814.mjs";
var o = e, p = TypeError, s = function(r) {
  if (o(r))
    throw new p("The method doesn't accept regular expressions");
  return r;
};
export {
  s as n
};
